"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _decorators = require("../utils/propTypes/decorators");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

var emptyBox = _react.default.createElement("span", null);

var maxHeightForSize = {
  sm: 10,
  md: 50,
  lg: 90
};
var getGrippieBackground = (0, _memoize.default)(function (use) {
  var fill = use === 'on-dark' ? _colors.OLAF : _colors.SLINKY;
  var svgStr = "<svg width='" + _sizes.DRAG_HANDLE_WIDTH + "' height='" + _sizes.DRAG_HANDLE_HEIGHT + "' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 " + _sizes.DRAG_HANDLE_WIDTH + " " + _sizes.DRAG_HANDLE_HEIGHT + "'><path fill='" + fill + "' d='M0 0h2v2H0V0zm0 8h2v2H0V8zm0 8h2v2H0v-2zM0 4h2v2H0V4zm0 8h2v2H0v-2zm0 8h2v2H0v-2zM3 0h2v2H3V0zm0 8h2v2H3V8zm0 8h2v2H3v-2zM3 4h2v2H3V4zm0 8h2v2H3v-2zm0 8h2v2H3v-2z'/></svg>";
  return (0, _styledComponents.css)(["background-image:url(\"data:image/svg+xml,", "\");"], encodeURIComponent(svgStr));
});

var grippieBackgroundMixin = function grippieBackgroundMixin(_ref) {
  var use = _ref.use;
  return getGrippieBackground(use);
};

var getGrippieOffset = (0, _memoize.default)(function (offsetX) {
  return (0, _styledComponents.css)(["background-position:", " calc(50% + 1px);background-repeat:no-repeat;"], offsetX);
});
var standaloneMixin = (0, _styledComponents.css)(["display:inline-block;line-height:", ";min-width:", ";&::after{content:'.';visibility:hidden;}"], _sizes.BASE_LINE_HEIGHT, _sizes.DRAG_HANDLE_WIDTH);
var sizedMixin = (0, _styledComponents.css)(["background-image:none !important;position:relative;&::before{content:' ';", ";background-repeat:repeat-y;position:absolute;", ":", ";top:0;width:", ";height:calc(100% - ", ");max-height:", "px;margin:", " 0;}"], grippieBackgroundMixin, function (_ref2) {
  var trailing = _ref2.trailing;
  return trailing ? 'right' : 'left';
}, _sizes.DRAG_HANDLE_OFFSET_X, _sizes.DRAG_HANDLE_WIDTH, _sizes.DRAG_HANDLE_HEIGHT, function (_ref3) {
  var size = _ref3.size;
  return maxHeightForSize[size];
}, _sizes.DRAG_HANDLE_OFFSET_Y);
var DragHandleChild = (0, _styledComponents.default)(function (_ref4) {
  var children = _ref4.children,
      className = _ref4.className,
      rest = _ref4.rest;
  return (0, _react.cloneElement)(children, Object.assign({
    className: (0, _classnames.default)(children.props.className, className)
  }, rest));
}).withConfig({
  displayName: "UIDragHandle__DragHandleChild",
  componentId: "sc-166wkbw-0"
})(["", ";", ";", ";", ";", ""], (0, _Styles.setGrabCursor)(), grippieBackgroundMixin, function (_ref5) {
  var standalone = _ref5.standalone,
      trailing = _ref5.trailing;
  var offsetX = _sizes.DRAG_HANDLE_OFFSET_X;

  if (standalone && trailing) {
    offsetX = '0';
  } else if (standalone) {
    offsetX = '50%';
  }

  if (trailing) offsetX = "calc(100% - " + offsetX + ")";
  return getGrippieOffset(offsetX);
}, function (_ref6) {
  var standalone = _ref6.standalone;
  return standalone && standaloneMixin;
}, function (_ref7) {
  var size = _ref7.size;
  return size !== 'default' && sizedMixin;
});

function UIDragHandle(props, context) {
  var children = props.children,
      className = props.className,
      position = props.position,
      size = props.size,
      use = props.use,
      _wrappedWithDnd = props._wrappedWithDnd,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "position", "size", "use", "_wrappedWithDnd"]);
  var connectDragSource = context.connectDragSource;

  if (process.env.NODE_ENV !== 'production') {
    if (typeof connectDragSource === 'function' && !_wrappedWithDnd) {
      _devLogger.default.warn({
        key: 'UIDragHandle: addon',
        message: 'Looks like you’re trying to use UIComponents’ `UIDragHandle` with ui-addon-draggable. Use `ui-addon-draggable/draggable/UIDragHandle` instead.'
      });
    }
  }

  return _react.default.createElement(DragHandleChild, {
    className: (0, _classnames.default)(className, 'is--draggable', {
      'is--draggable--sized': size !== 'default'
    }),
    rest: rest,
    size: (0, _tshirtSize.toShorthandSize)(size),
    standalone: children === emptyBox,
    trailing: position === 'end',
    use: use
  }, children);
}

UIDragHandle.defaultProps = {
  children: emptyBox,
  position: 'start',
  size: 'default',
  use: 'default'
};
UIDragHandle.propTypes = {
  children: _propTypes.default.element.isRequired,
  position: _propTypes.default.oneOf(['start', 'end']).isRequired,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'md', 'lg']), _propTypes.default.oneOf(['default'])]).isRequired,
  use: _propTypes.default.oneOf(['default', 'on-dark']).isRequired,
  _wrappedWithDnd: (0, _decorators.hidden)(_propTypes.default.bool)
};
UIDragHandle.contextTypes = {
  connectDragSource: _propTypes.default.func
};
UIDragHandle.displayName = 'UIDragHandle';
var _default = UIDragHandle;
exports.default = _default;
module.exports = exports.default;